export default __webpack_public_path__ + "./images/zu.7fe53161.png";